import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const ProgressCardContainer = styled.div`
  width: 100%;
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  border-radius: 4px;
  padding: 16px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.subtle};
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ProgressCardSpinnerContainer = styled.div`
  display: flex;
`;

export const ProgressCardContent = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ProgressCardTitle = styled.div`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  font-weight: 600;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ProgressCardDescription = styled.div`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-bottom: 8px;
`;

export const ProgressInfo = styled.div`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
